import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-00215ac2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_s"
};
import { ref } from "vue";
import TagItem from "@/components/tag-item/index.vue";
import UserItem from "@/components/user-item/index.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'screen_mg',
  setup(__props) {
    const tag_list = ref([{
      id: 1,
      name: "员工"
    }, {
      id: 3,
      name: "群聊"
    }]);
    const from = ref("");
    const cha_id = ref("");
    const item_chats = ref("");
    const user_id = ref("");
    const set_chart = item => {
      types.value = 1;
      cha_id.value = item.md5;
      item_chats.value = item;
      if (item?.user) {
        user_id.value = item.user.userid;
      }
    };
    const set_chart2 = item => {
      types.value = 2;
      cha_id.value = item.chat_id;
      item_chats.value = item;
    };
    const types = ref(1);
    const set_from = id => {
      from.value = id;
    };
    return (_ctx, _cache) => {
      const _component_chatting = _resolveComponent("chatting");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(UserItem, {
        onSet_from: set_from
      }), _createVNode(TagItem, {
        class: "margin-l-20",
        tag_list: tag_list.value,
        from: from.value,
        onSet_chart2: set_chart2,
        onSet_chart: set_chart
      }, null, 8, ["tag_list", "from"]), _createVNode(_component_chatting, {
        class: "margin-l-20",
        from: user_id.value,
        cha_id: cha_id.value,
        item_chats: item_chats.value,
        types: types.value
      }, null, 8, ["from", "cha_id", "item_chats", "types"])]);
    };
  }
});